import { User } from "@/@types/app/user";
import { appApi } from "../api";
import { FederalUnit } from "@/@types/app/FederalUnit";
import { Account } from "@/@types/app/Account";
import { HealthUnit } from "@/@types/esus/HealthUnit";
import { ModuleEnum } from "@/utils/enums/ModuleEnum";
import { Module } from "@/@types/app/Module";
import { UsersAccountAccess } from "./userAccountService";

type RegisterUserForm = {
	fullName: string;
	email: string;
	identifier: string;
	phone: string;
	occupation: string;
	ibgeCode: string;
	locale: string;
	federalUnitId?: number;
};

export async function checkUserExists(identifier: string) {
	const response = await appApi.get("/User/CheckUserExists", { identifier: identifier });
	return response.status === 200;
}

export async function registerUser(params: RegisterUserForm) {
	const response = await appApi.post("/user/registeruser", params);
	return response.status === 200;
}

export async function getUserInfoMasked(identifier: string) {
	const response = await appApi.get<User>("/User/GetUserInforMask", { identifier: identifier });
	return response.data || ({} as User);
}

export async function requestAccess(
	module: ModuleEnum,
	uf: string,
	ibgeCode?: string,
	roleId?: number
) {
	const response = await appApi.post("/User/RequestAccessToCity", {
		module,
		uf,
		ibgeCode,
		roleId,
	});
	return response.status === 200;
}

export async function getPermittedModules() {
	const { data } = await appApi.get<Module[]>(`/User/GetPermittedModules`);
	return data || [];
}

export async function getPermittedFederalUnits(module?: ModuleEnum) {
	const { data } = await appApi.get<FederalUnit[]>(`/User/GetPermittedFederalUnits`, { module });
	return data || [];
}

export async function getPermittedCities(module?: ModuleEnum, uf?: string) {
	const { data } = await appApi.get<Account[]>(`/User/GetPermittedCities`, { module, uf });
	return data || [];
}

export async function getPermittedHealthUnits(module?: ModuleEnum, uf?: string, ibgeCode?: string) {
	const { data } = await appApi.get<HealthUnit[]>("/User/GetPermittedHealthUnits", {
		module,
		uf,
		ibgeCode,
	});
	return data || [];
}

export async function updateUser(user: User) {
	const response = await appApi.post("/User/Update", user);
	return response.status === 200;
}

export async function changeIsLockedUser(user: UsersAccountAccess) {
	const response = await appApi.post(
		"/User/UserChangeIsLocked",
		{
			identifier: user.identifier,
		},
		{
			params: {
				identifier: user.identifier,
			},
		}
	);
	return response.status === 200;
}
